import type { FC, MouseEvent } from 'react';
import React, { useMemo } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import classnames from 'classnames';
import styles from './NavigationItem.module.scss';
import type { NavItemProps } from './types';

type NavigationItemProps = { isAdminPage?: boolean } & NavItemProps;
export const NavigationItem: FC<NavigationItemProps> = ({
  translate,
  translationKey,
  link,
  Icon,
  isAdminPage,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const handleNavigate = (ev: MouseEvent<HTMLAnchorElement>) => {
    ev.preventDefault();
    navigate(link);
    window.scrollTo({
      top: 0,
    });
  };

  const isActive = useMemo(
    () =>
      location.pathname.substring(location.pathname.lastIndexOf('/') + 1) ===
      link,
    [link, location.pathname],
  );
  return (
    <div
      className={classnames(styles.navigationItem, {
        [styles.adminNavigationItemContainer]: isAdminPage,
        '!pl-0': isActive,
      })}
    >
      <NavLink
        className={({ isActive }) =>
          classnames(
            styles.menuItem,
            'font-sans text-base transition-colors hover:text-gray-500 py-4 px-5',
            {
              [styles.active]: isActive && isAdminPage,
              [styles.adminNavigationItem]: isAdminPage,
            },
          )
        }
        id={translationKey}
        onClick={handleNavigate}
        to={link}
      >
        {Icon && <Icon />}
        <span>{translate(translationKey)}</span>
      </NavLink>
    </div>
  );
};
